import * as zod from 'zod';

import { Conditional, Expression } from '../../types';

export default zod.union([
  zod.object({
    milliseconds: zod.number().int().nonnegative(),
  }),
  zod.object({
    expression: Expression,
  }),
  zod.object({
    condition: Conditional,
  }),
]);
